import React, { useEffect, useState } from "react";
import { makeStyles, Grid, Button } from "@material-ui/core/";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
export default function Pagination({
  paginate,
  totalPosts,
  postsPerPage,
  setScroll,
}) {
  const pageNumbers = [];
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const [click, setClick] = useState(false);
  return (
    <div style={{ textAlign: "center" }}>
      <Button
        onClick={() => {
          paginate(currentPage - 1);
          window.scroll(0, 600);
          setCurrentPage(currentPage - 1);
        }}
        disabled={currentPage < 2}
        style={{ display: "inline-block" }}
      >
        <ArrowBackIosIcon style={{ paddingTop: "6px" }} />
      </Button>
      <div style={{ display: "inline-block", height: "50px" }}>
        {pageNumbers.map((number) => (
          <Button
            style={{
              display: "inline-block",
              maxWidth: "40px",
              maxHeight: "40px",
              minWidth: "40px",
              minHeight: "40px",
              backgroundColor: number === currentPage ? "black" : null,
              color: number === currentPage ? "white" : null,
              borderRadius: 50,

              padding: "0",
            }}
            onClick={() => {
              paginate(number);
              window.scroll(0, setScroll);
              setCurrentPage(number);
              setClick(true);
            }}
          >
            {number}
          </Button>
        ))}
      </div>
      <Button
        onClick={() => {
          paginate(currentPage + 1);
          window.scroll(0, 600);
          setCurrentPage(currentPage + 1);
        }}
        disabled={currentPage > totalPages - 1}
        style={{ display: "inline-block" }}
      >
        <ArrowForwardIosIcon style={{ paddingTop: "6px" }} />
      </Button>
    </div>
  );
}
